var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowNoteNook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.666 1V6.33333C13.666 6.68695 13.8065 7.02609 14.0565 7.27614C14.3066 7.52619 14.6457 7.66667 14.9993 7.66667H20.3327",
    stroke: "#FAA32D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33268 15.6667H8.34602M13.666 15.6667H13.6793M17.666 25H4.33268C3.62544 25 2.94716 24.719 2.44706 24.219C1.94697 23.7189 1.66602 23.0406 1.66602 22.3333V3.66667C1.66602 2.95942 1.94697 2.28115 2.44706 1.78105C2.94716 1.28095 3.62544 1 4.33268 1H13.666L20.3327 7.66667V22.3333C20.3327 23.0406 20.0517 23.7189 19.5516 24.219C19.0515 24.719 18.3733 25 17.666 25Z",
    stroke: "#FAA32D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 21.001C9.11454 20.4562 10.0452 20.1641 10.9987 20.1641C11.9522 20.1641 12.8829 20.4562 13.6654 21.001",
    stroke: "#FAA32D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowNoteNook);
export default __webpack_public_path__ + "static/media/yellowNoteNook.0750a07e3079f5776030035d71ad8ef3.svg";
export { ForwardRef as ReactComponent };